import { useFormikContext } from 'formik';
import { Option } from '../../interfaces';
import SelectInput from './SelectInput';
import DollarInput from './DollarInput';
import { CreateAptValues } from '../../utils/form/appointmentForm';

export const priceOptions: Option[] = [
  { value: 'FIXED', label: 'Set Price' },
  { value: 'RANGE', label: 'Price Range' },
  { value: 'HOURLY', label: 'Hourly Price' },
];

interface Props {
  disabled?: boolean;
}

export default function PriceInputs({ disabled = false }: Props) {
  const { values, setFieldValue, setFieldTouched } =
    useFormikContext<CreateAptValues>();

  return (
    <>
      <div className="input-row">
        <SelectInput
          values={values}
          setFieldValue={setFieldValue}
          name="priceType"
          label="Price Type"
          options={priceOptions}
          placeholder="Select price type"
          disabled={disabled}
        />
        <DollarInput
          name="price"
          label="Set Price"
          placeholder="Enter price"
          values={values}
          setFieldValue={setFieldValue}
          disabled={disabled}
          hidden={values.priceType !== 'FIXED'}
          setFieldTouched={setFieldTouched}
        />
        <DollarInput
          name="hourlyPrice"
          label="Hourly Price"
          placeholder="Enter hourly price"
          values={values}
          setFieldValue={setFieldValue}
          disabled={disabled}
          hidden={values.priceType !== 'HOURLY'}
          setFieldTouched={setFieldTouched}
        />
      </div>
      <div className="input-row">
        <DollarInput
          name="minPrice"
          label="Min Price"
          placeholder="Enter min"
          values={values}
          setFieldValue={setFieldValue}
          disabled={disabled}
          hidden={values.priceType !== 'RANGE'}
          setFieldTouched={setFieldTouched}
        />
        <DollarInput
          name="maxPrice"
          label="Max Price"
          placeholder="Enter max"
          values={values}
          setFieldValue={setFieldValue}
          disabled={disabled}
          hidden={values.priceType !== 'RANGE'}
          setFieldTouched={setFieldTouched}
        />
      </div>
    </>
  );
}
